import Icon from '@dtvgo/icon';
import PlayerButton from '../PlayerButton/PlayerButton.js';
import './BigPlayButton.scss';
import { jsx } from 'react/jsx-runtime';
import '../PlayerButton/PlayerButton.scss';

/* External */

function BigPlayButton(_ref) {
  var tooltip = _ref.tooltip;
  return /*#__PURE__*/jsx(PlayerButton, {
    className: "dtv-common-c-big-play-button",
    tooltip: tooltip,
    children: /*#__PURE__*/jsx(Icon, {
      name: "play",
      className: "dtv-common-c-big-play-button__icon"
    })
  });
}
BigPlayButton.defaultProps = {
  tooltip: ''
};

export { BigPlayButton as default };
//# sourceMappingURL=BigPlayButton.js.map
